import { AuditWorkpaperSummary } from '../../Models/Api/strongbox.financialportal';

import { GetAuditWorkpapers } from '../../Services/AuditService';

import { LogException } from '../../Utils/Logging';

import {
    AppThunkActionAsync
} from '../index';
import { KnownAction as uiKnownActions, actionCreators as uiStateActions } from '../UIState';
import {
    AuditWorkpapersActions,
    KnownAction,
} from './Actions';

/**
 * Loads the set of audit workpapers from the back end. Intended to be called when the
 * "Run Audit Workpapers" button is pressed; it only actually fetches the first time -
 * subsequent calls are a no-op while a load is in flight or once one has completed.
 */
const LoadAuditWorkpapers = (): AppThunkActionAsync<AuditWorkpaperSummary[], KnownAction | uiKnownActions> =>
    async (dispatch, getState): Promise<AuditWorkpaperSummary[]> => {
        const auditWorkpapersState = getState().auditWorkpapers;

        // Only load the first time - skip if a load is in flight or has already completed.
        if (auditWorkpapersState && (auditWorkpapersState.loaded || auditWorkpapersState.loading)) {
            return auditWorkpapersState.workpapers;
        }

        const workingName = `LoadAuditWorkpapers`;

        dispatch(uiStateActions.SetPortalWorking(workingName));

        try {
            dispatch({ type: AuditWorkpapersActions.LoadStart });

            const response = await GetAuditWorkpapers();
            const workpapers = (response && response.workpapers) || [];

            dispatch({
                type: AuditWorkpapersActions.LoadComplete,
                workpapers,
            });

            return workpapers;
        } catch (e) {
            const errorMsg = 'Loading audit workpapers action creator failed';

            console.error(errorMsg);
            console.error(e);

            LogException(errorMsg, e);

            dispatch({
                type: AuditWorkpapersActions.LoadError,
                error: errorMsg,
            });

            return [];
        } finally {
            dispatch(uiStateActions.SetPortalIdle(workingName));
        }
    }

export const actionCreators = {
    LoadAuditWorkpapers,
};
